import { gql } from 'apollo-boost';

export const GET_PEOPLE_CATEGORIES = gql`
    query getPeopleCategories($includeArchived: Boolean) {
        peopleCategories(includeArchived: $includeArchived) {
            uid
            title
            order
            archived
        }
    }
`;

export const GET_PEOPLE = gql`
    query getPeople {
        people {
            uid
            type
            order
            name
            department
            email
            description
            profile {
                type
                filename
                url
            }
            category {
                uid
                title
                order
            }
        }
    }
`;